import React, { useEffect, useState } from "react";
import moment from "moment";

// External components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataBreachRiskIndicator from "components/DataBreachRiskIndicator";

// Translation
import { useTranslation } from "react-i18next";

// APIs
import getDataBreaches from "api/dataBreach/getDataBreaches";

// MUI
import { Icon, IconButton, Tooltip } from "@mui/material";
import { useMaterialUIController } from "context";
import { useNavigate } from "react-router-dom";

const DataBreach = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { user } = controller;

  const [data, setData] = useState(null);

  const getData = async () => {
    try {
      const { results } = await getDataBreaches();
      setData(results);
    } catch (e) {
      console.log("error --->", e);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const goToDetails = (id) => {
    navigate(`/dataBreaches/${id}`);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Title */}
      <h2 className="page-title">{t("sidenav.data_breach")}</h2>
      {/* Page description */}

      <p style={{ fontSize: "small" }}>{t("dataBreach.page_description")}</p>
      {/* Table */}
      <div className="table_users_list" style={{ maxWidth: "900px", marginTop: "20px" }}>
        <table className="table-content" cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>{t("dataBreach.date")}</th>
              <th style={{ textAlign: "center" }}>{t("dataBreach.threat_actor_name")}</th>
              <th style={{ textAlign: "center" }}>{t("dataBreach.description")}</th>
              <th style={{ textAlign: "center" }}>{t("dataBreach.victim_nation")}</th>
              <th style={{ textAlign: "center" }}>{t("dataBreach.record_count")}</th>
              <th style={{ textAlign: "center" }}>{t("dataBreach.details")}</th>
              <th style={{ textAlign: "center" }}>{t("stealers.status")}</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0
              ? data.map((breach) => (
                  <tr key={breach.id}>
                    <td>
                      {moment(breach.publishedDate || breach.incidentDate).format("DD/MM/YYYY")}
                    </td>
                    <td>{breach.threatActor?.name || "N/A"}</td>
                    <td style={{ maxWidth: "300px" }}>{breach.shortDescription}</td>
                    <td>{breach.victim?.country || "N/A"}</td>
                    <td style={{ textAlign: "center" }}>
                      <div
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        {breach.results?.map((r) => r?.records || 0)?.reduce((p, a) => p + a, 0) ||
                          0}
                        <DataBreachRiskIndicator columns={breach.columns} showTooltip={true} />
                      </div>
                    </td>
                    <td>
                      <IconButton
                        onClick={() => {
                          goToDetails(breach.id);
                        }}
                        className="default-button"
                        size="small"
                        disableRipple
                      >
                        {t("details")}
                      </IconButton>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {user &&
                      user.id &&
                      breach.managedBy &&
                      breach.managedBy.length > 0 &&
                      breach.managedBy.includes(user.id) ? (
                        <Tooltip title={t("dataBreach.managed")} placement="top">
                          <Icon
                            style={{
                              marginLeft: "5px",
                              color: "green",
                            }}
                            fontSize="medium"
                          >
                            check
                          </Icon>
                        </Tooltip>
                      ) : (
                        <Tooltip title={t("dataBreach.not_managed_yet")} placement="top">
                          <Icon
                            style={{
                              marginLeft: "5px",
                              color: "red",
                            }}
                            fontSize="medium"
                          >
                            close
                          </Icon>
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default DataBreach;
